import * as React from 'react'

const MTLUSD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <g clipPath='url(#clip0_826_6741)'>
      <path
        d='M11.7651 34.769C10.7871 34.769 10 33.9657 10 32.9781V24.0282V20.177V15.0215C10 14.0339 10.7871 13.2306 11.7651 13.2306C12.7432 13.2306 13.5303 14.0339 13.5303 15.0215V32.9781C13.5256 33.9657 12.7385 34.769 11.7651 34.769Z'
        fill='url(#paint0_linear_826_6741)'
      />
      <path
        d='M36.2348 34.769C35.2615 34.769 34.4697 33.9657 34.4697 32.9781V15.0215C34.4697 14.0339 35.2615 13.2306 36.2348 13.2306C37.2082 13.2306 38 14.0339 38 15.0215V32.9781C38 33.9657 37.2082 34.769 36.2348 34.769Z'
        fill='url(#paint1_linear_826_6741)'
      />
      <path
        d='M19.9201 31.0361C18.9468 31.0361 18.155 30.2375 18.155 29.2452V18.7548C18.155 17.7672 18.9468 16.9638 19.9201 16.9638C20.8935 16.9638 21.6853 17.7672 21.6853 18.7548V29.2452C21.6853 30.2328 20.8935 31.0361 19.9201 31.0361Z'
        fill='url(#paint2_linear_826_6741)'
      />
      <path
        d='M28.0798 28.0215C27.1064 28.0215 26.3147 27.2182 26.3147 26.2306V21.8028C26.3147 20.8152 27.1064 20.0119 28.0798 20.0119C29.0532 20.0119 29.845 20.8152 29.845 21.8028V26.2306C29.8403 27.2229 29.0532 28.0215 28.0798 28.0215Z'
        fill='url(#paint3_linear_826_6741)'
      />
    </g>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#CAD0E1' />
    <defs>
      <linearGradient
        id='paint0_linear_826_6741'
        x1='9.95772'
        y1='23.8097'
        x2='47.5052'
        y2='27.6539'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#4400E2' />
        <stop offset='0.0411' stopColor='#7013C5' />
        <stop offset='0.0866' stopColor='#9A25AA' />
        <stop offset='0.1333' stopColor='#BC3494' />
        <stop offset='0.1804' stopColor='#D73F82' />
        <stop offset='0.2284' stopColor='#EA4876' />
        <stop offset='0.2776' stopColor='#F54C6E' />
        <stop offset='0.33' stopColor='#F94E6C' />
        <stop offset='1' stopColor='#FFD402' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_826_6741'
        x1='10.2189'
        y1='21.2582'
        x2='47.7664'
        y2='25.1024'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#4400E2' />
        <stop offset='0.0411' stopColor='#7013C5' />
        <stop offset='0.0866' stopColor='#9A25AA' />
        <stop offset='0.1333' stopColor='#BC3494' />
        <stop offset='0.1804' stopColor='#D73F82' />
        <stop offset='0.2284' stopColor='#EA4876' />
        <stop offset='0.2776' stopColor='#F54C6E' />
        <stop offset='0.33' stopColor='#F94E6C' />
        <stop offset='1' stopColor='#FFD402' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_826_6741'
        x1='10.0448'
        y1='22.9593'
        x2='47.5923'
        y2='26.8035'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#4400E2' />
        <stop offset='0.0411' stopColor='#7013C5' />
        <stop offset='0.0866' stopColor='#9A25AA' />
        <stop offset='0.1333' stopColor='#BC3494' />
        <stop offset='0.1804' stopColor='#D73F82' />
        <stop offset='0.2284' stopColor='#EA4876' />
        <stop offset='0.2776' stopColor='#F54C6E' />
        <stop offset='0.33' stopColor='#F94E6C' />
        <stop offset='1' stopColor='#FFD402' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_826_6741'
        x1='10.1299'
        y1='22.1281'
        x2='47.6774'
        y2='25.9722'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#4400E2' />
        <stop offset='0.0411' stopColor='#7013C5' />
        <stop offset='0.0866' stopColor='#9A25AA' />
        <stop offset='0.1333' stopColor='#BC3494' />
        <stop offset='0.1804' stopColor='#D73F82' />
        <stop offset='0.2284' stopColor='#EA4876' />
        <stop offset='0.2776' stopColor='#F54C6E' />
        <stop offset='0.33' stopColor='#F94E6C' />
        <stop offset='1' stopColor='#FFD402' />
      </linearGradient>
      <clipPath id='clip0_826_6741'>
        <rect width='28' height='21.5385' fill='white' transform='matrix(1 0 0 -1 10 34.769)' />
      </clipPath>
    </defs>
  </svg>
)

export default MTLUSD
